export class SetOrganisationRoleError {
  public static readonly type = '[Authorisation] SetOrganisationRoleError';
  constructor(public readonly error: Error) {}
}
